// extracted by mini-css-extract-plugin
export var layoutContainer = "_48-0";
export var layoutContainerNoRounding = "_48-6";
export var layoutContainerOpen = "_48-5";
export var layoutContainerResizing = "_48-1";
export var mainContent = "_48-2";
export var resizeDivider = "_48-3";
export var slidePanel = "_48-4";